import { render, staticRenderFns } from "./RemoveRole.vue?vue&type=template&id=7d5de7b5&lang=pug"
import script from "./RemoveRole.vue?vue&type=script&lang=js"
export * from "./RemoveRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports